import './Grid.scss'
import { useState, useEffect } from 'react'
import loader from "../../assets/images/loader.gif";
import { ArrowUp, ArrowDown, ChevronRight, ChevronDown } from 'react-bootstrap-icons';
import { GridHeader, Filter, FilterOption, GridRow } from './Grid'
import Paginations from '../pagination/Paginations'

export interface ExpandableData {
  headers: GridHeader[]
  rows: ExpandableRow[]
  filters?: Filter[]
  ShowLoader?: boolean
  errorMessage?: string
  isColumn?: boolean
  dateFilter?: FilterOption[]
  onClickRow?: boolean
  isSelectedRow?: any
  hoverRow?: any
  storeKey?: string
  gridId?: string
}

export interface ExpandableRow {
  header: string
  isExpand: boolean
  data: GridRow[]
  class?: string
}

const ExpandableGrid = (props: ExpandableData) => {
  const [headers, setHeaders] = useState(
    props.headers.map((option: GridHeader) => {
      if (option.isShow === undefined) { option.isShow = true }
      return { ...option }
    }));
  const [rows, setRows] = useState([...props.rows])
  const [currentPage, setCurrentPage] = useState(1)
  const [perPageItem, setPerPageItem] = useState(20);
  const [data, setData] = useState<ExpandableRow[]>([]);

  useEffect(() => {
    setHeaders(
      props.headers.map((option: GridHeader) => {
        if (option.isShow === undefined) {
          option.isShow = true
        }

        return { ...option }
      })
    )
  }, [props.headers])

  useEffect(() => {
    var start = perPageItem * (currentPage - 1)
    setData(props.rows.slice(start, start + perPageItem))
  }, [currentPage])

  useEffect(() => {
    setRows(props.rows)
    var start = perPageItem * (currentPage - 1)
    setData(props.rows.slice(start, start + perPageItem))
  }, [props.rows])

  useEffect(() => {
    var table = document.getElementById('resizable')
    resizableGrid(table)
    function resizableGrid(table: any) {
      var row = table.getElementsByTagName('tr')[0],
        cols = row ? row.children : undefined
      if (!cols) return

      var tableHeight = table.offsetHeight

      for (var i = 0; i < cols.length; i++) {
        var div = createDiv(tableHeight)
        cols[i].appendChild(div)
        cols[i].style.position = 'relative'
        setListeners(div)
      }

      function setListeners(div: any) {
        var pageX: any,
          curCol: any,
          nxtCol: any,
          curColWidth: any,
          nxtColWidth: any,
          tableWidth: any

        div.addEventListener('mousedown', function (e: any) {
          var temp = document.getElementById('resizable')
          if (temp) {
            tableWidth = temp.offsetWidth
          }

          curCol = e.target.parentElement
          nxtCol = curCol.nextElementSibling
          pageX = e.pageX

          var padding = paddingDiff(curCol)

          curColWidth = curCol.offsetWidth - padding
          //  if (nxtCol)
          //nxtColWidth = nxtCol.offsetWidth - padding;
        })

        div.addEventListener('mouseover', function (e: any) {
          e.target.style.borderRight = '2px solid #0000ff'
        })

        div.addEventListener('mouseout', function (e: any) {
          e.target.style.borderRight = ''
        })

        document.addEventListener('mousemove', function (e) {
          if (curCol) {
            var diffX = e.pageX - pageX
            curCol.style.width = curColWidth + diffX + 'px'
            var temp1 = document.getElementById('resizable')
            if (temp1 && temp1.style) {
              temp1.style.width = tableWidth + diffX + 'px'
            }
          }
        })

        document.addEventListener('mouseup', function (e) {
          curCol = undefined
          nxtCol = undefined
          pageX = undefined
          nxtColWidth = undefined
          curColWidth = undefined
        })
      }

      function createDiv(height: any) {
        var div = document.createElement('div')
        if (div && div.style) {
          div.style.top = '0'
          div.style.right = '0'
          div.style.width = '5px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
        }

        return div
      }

      function paddingDiff(col: any) {
        if (getStyleVal(col, 'box-sizing') == 'border-box') {
          return 0
        }

        var padLeft = getStyleVal(col, 'padding-left')
        var padRight = getStyleVal(col, 'padding-right')
        return parseInt(padLeft) + parseInt(padRight)
      }

      function getStyleVal(elm: any, css: any) {
        return window.getComputedStyle(elm, null).getPropertyValue(css)
      }
    }
  }, [headers])

  const updateUserPreference = (data: GridHeader[]) => {
    if (props.storeKey) {
    }
  }

  const activeCollaspse = (e: any) => {
    if (e.target.parentElement.classList.contains('active')) {
      e.target.parentElement.classList.remove('active')
    } else {
      e.target.parentElement.classList.add('active')
    }
  }

  const sorting = (index: number) => {

    setHeaders(
      headers.map((option: GridHeader, i: number) =>
        i === index
          ? {
            ...option,
            isAsc: !option.isAsc,
            isDesc: option.isAsc
          }
          : {
            ...option,
            isAsc: false,
            isDesc: false
          }
      )
    )
  }

  const [styledRow, setStyledRow] = useState<Number>()

  const onSelectRow = (e: any, data: any) => {
    if (props.onClickRow) {
      setStyledRow(e)
      props.isSelectedRow(e, data)
    }
  }

  const onclickArrow = (index: number) => {
    setData(
      data.map((option: ExpandableRow, i: number) =>
        i == index ? { ...option, isExpand: !option.isExpand } : { ...option }
      )
    )
  }

  return (
    <div className="grid-div" data-testid="comp-sawin-table">
      <div className={props.ShowLoader === false ? 'table-scroll' : 'table-scroll px-0'}>
        <table className="grid-table" id="resizable">
          <thead>
            <tr>
              <th></th>
              {headers.map((header: GridHeader, i) =>
                header.isShow === false ? (
                  ''
                ) : header.isSorting === false ? (
                  <th
                    className={
                      'cursor-pointer text-center ' +
                      (header.isFreeze == true ? 'freeze-column' : '')
                    }
                    style={{ width: header.width ? header.width : '' }}
                    key={i.toString()}
                  >
                    {header.title}{' '}
                  </th>
                ) : (
                  <th
                    key={i.toString()}
                    className={
                      'cursor-pointer text-center ' +
                      (header.isFreeze == true ? 'freeze-column' : '')
                    }
                    style={{ width: header.width ? header.width : '' }}
                    onClick={() => sorting(i)}
                  >
                    {header.title}

                    <span className="sorting">
                      {header.isDesc ? <ArrowUp /> : null}
                      {header.isAsc ? <ArrowDown /> : null}
                    </span>
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {props.ShowLoader === true || data.length == 0 ? (
              <></>
            ) : (
              data.map((expandableRow: ExpandableRow, r) => {
                return (
                  <>
                    <tr
                      className={"expadable-header"}
                      onClick={(event) => activeCollaspse(event)}
                      key={'body_header_data_' + r.toString()}
                      style={{ backgroundColor: expandableRow.isExpand ? "#f1f1f1" : "" }}
                    >
                      <td
                        colSpan={headers.length + 1}
                        onClick={() => {
                          onclickArrow(r)
                        }}
                      >
                        <div className='d-flex align-items-center p-1 border'>
                          {expandableRow.isExpand ? (
                            <ChevronDown className="expandIcon" />
                          ) : (
                            <ChevronRight
                              className="expandIcon"
                              onClick={() => {
                                onclickArrow(r)
                              }}
                            />
                          )}{' '}
                          {expandableRow.header}
                        </div>
                      </td>
                    </tr>

                    {expandableRow.isExpand && expandableRow.data.map((row: GridRow, i) => (
                      <tr
                        onClick={() => onSelectRow(i, row)}
                        key={'body_data_' + i.toString()}
                        className={
                          (styledRow == i ? 'selected-row' : '') ||
                          (props.hoverRow ? 'hover-styled-row' : '') + ' ' + 'expanded-row'
                        }
                      >
                        <td></td>
                        {headers.map((header: GridHeader, j) =>
                          header.isShow === false ? (
                            ''
                          ) : (
                            <td
                              key={'row_' + i + '_' + j}
                              className={
                                (header.class?.toString() ||
                                  (styledRow == i ? 'selected-row-text' : '')) +
                                (header.isFreeze == true ? ' freeze-column' : '')
                              }
                            >
                              {row.data[j] ? (
                                row.data[j].type === 'HTML' ? (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: row.data[j].value
                                    }}
                                  />
                                ) : (
                                  row.data[j].value
                                )
                              ) : (
                                '-'
                              )}
                            </td>
                          )
                        )}
                      </tr>
                    ))}
                  </>
                )
              })
            )}
          </tbody>
        </table>
        {rows.length == 0 && props.ShowLoader === false ? (
          <div>
            <div className="error-message">{props.errorMessage}</div>
          </div>
        ) : null}
      </div>
      {props.ShowLoader === true ? (
        <div className="">
          <div></div>
          <div style={{ textAlign: 'center', marginTop: '10%' }}>
            <img style={{ position: 'relative' }} src={loader} alt="No loader found" />
            <div style={{ position: 'relative', color: 'white' }}>Loading...</div>
          </div>
        </div>
      ) : null}

      {rows.length > 0 ? (
        <div className="d-flex flex-row justify-content-between pb-3 align-items-center pagination-row">
          <div className="d-flex col-6 align-items-center">
            <Paginations
              className=" "
              changePage={(page: number) => setCurrentPage(page)}
              totalItems={rows.length}
              itemsCountPerPage={perPageItem}
            />
          </div>
          <div className="showing-text ps-3 col-6 text-end font-12">
            {perPageItem * (currentPage - 1) + 1} -{' '}
            {(currentPage - 1) * perPageItem + perPageItem > rows.length
              ? rows.length
              : (currentPage - 1) * perPageItem + perPageItem}{' '}
            of {rows.length}
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default ExpandableGrid
